var map = {
	"./blocks.svg": 707,
	"./choose.svg": 708,
	"./document.svg": 709,
	"./empty.svg": 710,
	"./felix-update.svg": 711,
	"./felix.svg": 712,
	"./file-add.svg": 713,
	"./file-collect.svg": 714,
	"./files.svg": 715,
	"./finance.svg": 716,
	"./no-data.svg": 717,
	"./photo.svg": 718,
	"./thought.svg": 719,
	"./usability.svg": 720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706;